module.exports =  {

  alertTxt: "We've upgraded to Version 3.",
  title: "LedgerDex Version 3 Annoucement",
  contents: `
    <p>We are very excited to announce that LedgerDex has been upgraded to Version 3.</p>

    <h3 class="mb-2">Why Upgrade?</h3>

    <p>LedgerDex is built on top of the 0x protocol. Recently <a href="https://blog.0xproject.com/0x-the-community-owned-liquidity-api-26da5732447e" target="_blank">0x upgraded to V3</a> with a new smart contract and many exciting new features. 0x's old smart contract (V2) will retire soon. To take advantage of the 0x V3 smart contract, we have upgraded our platform to Version 3.</p>

    <h3 class="mb-2">What's New in Version 3?</h3>

    <p>
    <ul>
      <li><strong>New Smart Contract</strong>: We are now using the new 0x V3 smart contract.</li>
      <li><strong>Better Trading Liquidity</strong>: By sharing orders via the <a href="https://blog.0xproject.com/0x-roadmap-2019-part-3-networked-liquidity-0x-mesh-9a24026202b3" target="_blank">0x Mesh network</a>, traders will enjoy a better networked liquidity.</li>
      <li><strong>Mobile-Friendly</strong>: Now users can access LedgerDex on mobile phones by using crypto wallet apps with a dApp browser (currently working with imToken). </li>
      <li><strong>Better User Interface</strong>: We have re-written our user interface from the ground up. Our app is now much more user-friendly!</li>
      <li><strong>Allow Geo-Blocking Bypass</strong>: We still block users from non-supporting countries such as the United States. However, if you are temporarily traveling in those regions or using a VPN with an IP address for blocked regions, you can now bypass our blocking.</li>
      <li><strong>Allow Trading Fees Paid in Non-ZRX Tokens</strong>: In older versions of the 0x protocols, maker and taker fees can only be paid in the ZRX token. Now this restriction has be removed. Any ERC20 tokens can be specified for trading fees.</li>
      <li><strong>Takers Will Pay a Protocol Fee</strong>: Version 3 of the 0x protocol has added a protocol fee that needs to be paid by the taker.</li>
    </ul>
    </p>

    <h3 class="mb-2">Compatibility Between Version 3 and Version 2</h3>

    <p>
    <ul>
      <li>User's token balance (including WETH) will stay the same.</li>
      <li>User's token tracking list and trading pair watchlist will remain the same.</li>
      <li>Token allowances set on Version 2 will remain valid on Version 3. No need to re-set allowances.</li>
      <li>Orders created on Version 2 will <strong>NOT</strong> be accessible on Version 3.</li>
    </ul>
    </p>

    <!--
    <h3 class="mb-2">Actions Required from Users</h3>

    <p>If you have used LedgerDex's previous version (Version 2) before, you might need to take the following actions:</p>
    <p>
    <ul>
      <li><strong>Cancel Version 2 Orders If Needed:</strong> If you have existing order created on Version 2 that are still fillable, you have two choices: 1) You can take no action and leave them untouched until they expire or are filled by traders still using the 0x V2 smart contract. 2) If you want, you can cancel these orders by visiting our <a href="https://app-v2.ledgerdex.com" target="_blank">old version</a>. You will need to pay Ethereum Gas fees for order cancellation.</li>
    </ul>
    </p>

    <h3 class="mb-2">How to Access Old Version (Version 2)</h3>

    <p>To ensure a smooth migration process, we have made the old version (Version 2) of our platform available for a limited time at this link: <a href="https://app-v2.ledgerdex.com" target="_blank">https://app-v2.ledgerdex.com</a>. Please note that we will remove access to the old version soon.</p>
    -->

    <p>If you have any questions regarding our Version 3 migration, please feel free to contact us!</p>
  `,

}

